// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--tqiZP";
export var patientResources = "styles-module--patientResources--X6+bd";
export var resourcesFlex = "styles-module--resourcesFlex--Xp6Ca";
export var someclass = "styles-module--someclass--cEBFm";
export var textContainer = "styles-module--textContainer--ZjPZ0";